/* LMM Ratgeber-Article — Sticky-TOC + Scrollspy (Blog 'ratgeber' only).
   Klont das kuratierte Inline-TOC (.lmm-ratgeber-toc) in die rechte Aside-Spalte
   und markiert beim Scrollen den aktiven Abschnitt. Ohne JS bleibt das Layout
   einspaltig mit Inline-TOC (siehe CSS-Fallback). Idempotent, defer-geladen. */
(function () {
  'use strict';

  /* Muss zum CSS scroll-margin-top der Headings passen (lmm-ratgeber-content.css). */
  var SCROLL_OFFSET = 90;

  function buildToc(root) {
    var aside = root.querySelector('[data-lmm-rg-toc]');
    var inline = root.querySelector('.lmm-ratgeber-content .lmm-ratgeber-toc');
    if (!aside || !inline || aside.querySelector('.lmm-rg-toc')) return null;

    var list = inline.querySelector('ul, ol');
    if (!list) return null;

    var nav = document.createElement('nav');
    nav.className = 'lmm-rg-toc';
    nav.setAttribute('aria-label', 'Inhalt');

    var titleEl = inline.querySelector('h2, h3');
    var title = document.createElement('p');
    title.className = 'lmm-rg-toc__title';
    title.textContent = titleEl ? titleEl.textContent.trim() : 'Inhalt';
    nav.appendChild(title);
    nav.appendChild(list.cloneNode(true));

    aside.appendChild(nav);
    root.classList.add('lmm-rg-has-toc');
    return nav;
  }

  function scrollSpy(nav) {
    if (!('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    var targets = [];
    links.forEach(function (a) {
      var id;
      try { id = decodeURIComponent(a.getAttribute('href').slice(1)); }
      catch (e) { id = a.getAttribute('href').slice(1); }
      var el = id && document.getElementById(id);
      if (el) { map[id] = a; targets.push(el); a.__lmmTarget = el; }
    });
    if (!targets.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        var active = map[entry.target.id];
        if (active) active.classList.add('is-active');
      });
    }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });

    targets.forEach(function (t) { obs.observe(t); });
  }

  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function currentScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  /* Absolute Soll-Scrollposition eines Ziel-Headings (live aus dem Layout berechnet,
     daher robust gegen späteres Umfließen). */
  function targetY(el) {
    var y = el.getBoundingClientRect().top + currentScrollY() - SCROLL_OFFSET;
    return y < 0 ? 0 : y;
  }

  /* Scrollt zum Ziel und HÄLT die Position kurz nach. Damit gewinnt der TOC-Sprung
     auch dann, wenn eine andere Ebene die Seite nachträglich verschiebt:
       - Theme-Editor (fängt Klicks ab und scrollt das iFrame eigenmächtig),
       - ein globaler Horizon-Scroll-/Anker-Handler,
       - Layout-Shift durch nachladende Bilder/Module/Sektionen.
     Sobald der Scroll zur Ruhe gekommen ist, wird die tatsächliche Position gegen das
     neu berechnete Ziel geprüft und – falls daneben – exakt korrigiert.
     Bricht sofort ab, wenn der Nutzer selbst scrollt (Rad/Touch/Scroll-Tasten). */
  function goToTarget(el) {
    var reduce = prefersReduced();
    try { window.scrollTo({ top: targetY(el), behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, targetY(el)); }

    var cancelled = false;
    var last = null;
    var stable = 0;
    var elapsed = 0;
    var STEP = 80;
    var MAX = 1400;

    function teardown() {
      cancelled = true;
      window.removeEventListener('wheel', teardown, true);
      window.removeEventListener('touchstart', teardown, true);
      window.removeEventListener('keydown', onKey, true);
    }
    function onKey(ev) {
      var k = ev.key;
      if (k === 'ArrowUp' || k === 'ArrowDown' || k === 'PageUp' || k === 'PageDown' ||
          k === 'Home' || k === 'End' || k === ' ' || k === 'Spacebar') teardown();
    }
    window.addEventListener('wheel', teardown, true);
    window.addEventListener('touchstart', teardown, true);
    window.addEventListener('keydown', onKey, true);

    function poll() {
      if (cancelled) return;
      var cur = currentScrollY();
      if (last !== null && Math.abs(cur - last) <= 1) stable++; else stable = 0;
      last = cur;
      elapsed += STEP;

      /* Scroll ist zur Ruhe gekommen (zwei stabile Messungen): Lage prüfen. */
      if (stable >= 2) {
        var want = targetY(el);
        if (Math.abs(cur - want) > 4) {
          window.scrollTo(0, want);   // exakt & sofort korrigieren
          last = want; stable = 0;
          if (elapsed < MAX) { setTimeout(poll, STEP); return; }
        }
        teardown();                    // richtig & ruhig -> fertig
        return;
      }
      if (elapsed < MAX) { setTimeout(poll, STEP); return; }

      var w = targetY(el);             // Sicherheitsnetz nach MAX
      if (Math.abs(currentScrollY() - w) > 4) window.scrollTo(0, w);
      teardown();
    }
    setTimeout(poll, STEP);
  }

  /* TOC-Klicks selbst übernehmen: Wir fangen den Klick in der CAPTURE-Phase auf
     document-Ebene ab (vor etwaigen Delegates anderer Ebenen), verhindern den nativen
     Anker-Sprung und scrollen kontrolliert via goToTarget(). Ziel bevorzugt aus
     __lmmTarget (zur Bauzeit referenziert) → immun gegen späteres Umschreiben der IDs.
     Der URL-Hash wird per replaceState gesetzt (löst KEINEN nativen Scroll aus). */
  function bindTocClicks() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var toc = a.closest('.lmm-rg-toc, .lmm-ratgeber-toc');
      if (!toc || !toc.closest('.lmm-rg')) return;
      var id;
      try { id = decodeURIComponent(a.getAttribute('href').slice(1)); }
      catch (err) { id = a.getAttribute('href').slice(1); }
      if (!id) return;
      var el = (a.__lmmTarget && a.__lmmTarget.isConnected) ? a.__lmmTarget : document.getElementById(id);
      if (!el) return; // kein Ziel auflösbar -> nativen Sprung lassen
      e.preventDefault();
      e.stopPropagation();
      goToTarget(el);
      if (window.history && history.replaceState) {
        try { history.replaceState(null, '', '#' + id); } catch (e2) { /* Hash bewusst NICHT setzen (würde springen) */ }
      }
    }, true);
  }

  function init() {
    var root = document.querySelector('.lmm-rg');
    if (!root) return;
    bindTocClicks();
    var nav = buildToc(root);
    if (nav) scrollSpy(nav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
